import { createAction, props, union } from '@ngrx/store';
import { PayrollEntry, PayrollFilterInput } from 'app/api/payroll.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { PayrollQuery } from '../payroll.types';

const source = 'payroll';
const actions = 'api';

export const payrollRequested = createAction(
    `[${source}][${actions}] Payroll requested`,
    props<{ query: PayrollQuery }>()
);
export const payrollLoaded = createAction(
    `[${source}][${actions}] Payroll loaded`,
    props<{ entries: PayrollEntry[] }>()
);
export const payrollCancelled = createAction(
    `[${source}][${actions}] Payroll cancelled`,
    props<{ errorMessage: string }>()
);

export const  payrollRemoveAll = createAction(
    `[${source}][${actions}] Payroll Remove all`
);

const all = union({
    payrollRequested,
    payrollLoaded,
    payrollCancelled,
    payrollRemoveAll,
});

export type payrollActionsUnion = typeof all;
